import React from "react";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import ReactPlayer from "react-player";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../../components/Common/Permission";

const CampaignInfo = (props) => {
  const { activeCampaignDetails } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION];

  const hasOwnPropertyCheck = (element, key1, key2 = "") => {
    if (key2 == "") {
      return element.hasOwnProperty(key1);
    }
    return element.hasOwnProperty(key1) && element[key1].hasOwnProperty(key2);
  };

  return (
    <CampaignInfoContainer align="flex-start">
      <Permission requiredPerms={[allActions.CAMPAIGN_VIEW]}>
        <CampaignInfoContainer.LeftSection>
          <FlexContainer align="flex-start" className="mb-20">
            <LeftSection>
              {hasOwnPropertyCheck(activeCampaignDetails, "campaign_details") &&
                activeCampaignDetails.campaign_details.map((detail) => {
                  return <p>{detail.key}</p>;
                })}
              {hasOwnPropertyCheck(
                activeCampaignDetails,
                "notification_details",
                "type"
              ) && <p>Notification Type:</p>}
            </LeftSection>
            <RightSection>
              {hasOwnPropertyCheck(activeCampaignDetails, "campaign_details") &&
                activeCampaignDetails.campaign_details.map((detail) => {
                  return <p>{detail.value}</p>;
                })}
              {hasOwnPropertyCheck(
                activeCampaignDetails,
                "notification_details",
                "type"
              ) && (
                <p>{activeCampaignDetails["notification_details"]["type"]}</p>
              )}
            </RightSection>
          </FlexContainer>
          <NotificationTitle>
            {hasOwnPropertyCheck(
              activeCampaignDetails,
              "notification_details",
              "title"
            ) && (
              <p>{activeCampaignDetails["notification_details"]["title"]}</p>
            )}
          </NotificationTitle>
          <NotificationContent>
            {hasOwnPropertyCheck(
              activeCampaignDetails,
              "notification_details",
              "content"
            ) && (
              <p>{activeCampaignDetails["notification_details"]["content"]}</p>
            )}
          </NotificationContent>
          <div>
            {hasOwnPropertyCheck(
              activeCampaignDetails,
              "notification_details",
              "actions"
            ) && (
              <FlexContainer className="mb-30 mt-30">
                {activeCampaignDetails.notification_details.actions.map(
                  (item) => {
                    return (
                      <CTASection>
                        <p>CTA: {item.name}</p>
                        <p>Redirect: {item.deeplink}</p>
                      </CTASection>
                    );
                  }
                )}
              </FlexContainer>
            )}
          </div>
        </CampaignInfoContainer.LeftSection>
        <CampaignInfoContainer.RightSection>
          {hasOwnPropertyCheck(
            activeCampaignDetails,
            "notification_details",
            "image"
          ) &&
            activeCampaignDetails.notification_details.image != "" && (
              <ImageContainer>
                <p>Attached Image:</p>
                <img
                  src={activeCampaignDetails.notification_details.image}
                  alt="image"
                ></img>
              </ImageContainer>
            )}
          {hasOwnPropertyCheck(
            activeCampaignDetails,
            "notification_details",
            "media"
          ) &&
            activeCampaignDetails["notification_details"][
              "media"
            ].hasOwnProperty("url") &&
            activeCampaignDetails.notification_details.media.url != "" && (
              <VideoContainer>
                <p>Attached Media:</p>
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  width="70%"
                  height="250px"
                  url={activeCampaignDetails.notification_details.media.url}
                />
              </VideoContainer>
            )}
        </CampaignInfoContainer.RightSection>
      </Permission>
    </CampaignInfoContainer>
  );
};

const ImageContainer = styled.div`
  img {
    border-radius: 16px;
    width: 70%;
    height: 250px;
    margin-bottom: 50px;
  }
`;

const VideoContainer = styled.div`
  video {
    border-radius: 16px;
  }
`;

const CampaignInfoContainer = styled(FlexContainer)`
  padding: 1.5rem;
  border-bottom: 1px solid ${variables.borderColor};
  p {
    color: #9197a6;
    margin: 8px;
  }
`;

const CTASection = styled.div`
  justify-content: flex-start;
  flex: 0 1 50%;
`;

CampaignInfoContainer.LeftSection = styled.div`
  justify-content: flex-start;
  flex: 0 1 60%;
  background-color: #ffffff;
  padding: 2rem;
`;
CampaignInfoContainer.RightSection = styled.div`
  flex: 0 1 38%;
`;

const LeftSection = styled.div`
  justify-content: flex-start;
`;
const RightSection = styled.div`
  flex: 0 1 75%;
`;

const NotificationTitle = styled.div`
  background-color: #fbfbfb;
  height: 2.5em;
  width: 20em;
  border-radius: 3px;
  border: 1px solid ${variables.borderColor2};
  margin-left: 5px;
  margin-bottom: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;
const NotificationContent = styled.div`
  background-color: #fbfbfb;
  height: 10em;
  width: 40em;
  border-radius: 3px;
  border: 1px solid ${variables.borderColor2};
  margin-left: 5px;
  margin-bottom: 20px;
  overflow-y: auto;
`;

export default CampaignInfo;
